import { useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../styles/section-working.css";

import acc from "../../assets/motion 1.gif";
import look from "../../assets/motion 2.gif";
import chef from "../../assets/motion 3.gif";
import deli from "../../assets/motion 4.gif";

import Decouverte from "../../assets/Image 1-Découvrez la diversité de l'héritage.jpg";
import Contribution from "../../assets/image 2-Contribuez à la croissance des cuisiniers.jpeg";
import Gouter from "../../assets/image 3-Goûtez aux meilleurs plats ethniques.jpeg";

import { useSelector } from "react-redux";
import { t } from "../../translations";

const SectionWorking = () => {
  useEffect(() => {}, []);

  const lang = useSelector((state) => state.lang);

  return (
    <div className="section-working">
      <h2>{t("section_working.title", lang)}</h2>
      <div className="section-element">
        {[
          {
            text: t("section_working.steps.create_account", lang),
            img: acc
          },
          {
            text: t("section_working.steps.search_dishes", lang),
            img: look
          },
          {
            text: t("section_working.steps.make_order", lang),
            img: chef
          },
          {
            text: t("section_working.steps.receive_dish", lang),
            img: deli
          }
        ].map((item) => (
          <div className="section-item">
            <img src={item.img} alt="logo" />
            <br />
            <span>{item.text}</span>
          </div>
        ))}
      </div>
      <div
        className="certification"
        style={{
          marginTop: 50
        }}
      >
        {[
          {
            title: t("section_working.cert1.title", lang),
            description: t("section_working.cert1.description", lang),
            image: Decouverte
          },
          {
            title: t("section_working.cert2.title", lang),
            description: t("section_working.cert2.description", lang),
            image: Contribution
          },
          {
            title: t("section_working.cert3.title", lang),
            description: t("section_working.cert3.description", lang),
            image: Gouter
          }
        ].map((item, index) =>
          index === 1 ? (
            <div className="block-certification" key={index}>
              <div className="text">
                <h3>{item?.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>
              <img
                src={item?.image}
                alt="logo"
                style={{
                  borderRadius: 30
                }}
              />
            </div>
          ) : (
            <div className="block-certification" key={index}>
              <img
                src={item?.image}
                alt="logo"
                style={{
                  borderRadius: 30
                }}
              />
              <div className="text">
                <h3> {item?.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: item?.description }} />
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SectionWorking;
